import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Layout from "../../layout";
// import { useSelector } from "react-redux";
import _ from "lodash";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ArrowDown from "../../assets/images/arrowDown.svg";
import Bulb from "../../assets/images/bulb.svg";
import DisableRight from "../../assets/images/DisableRight.svg";
import Homeicon from "../../assets/images/homeIcon.svg";
import InfoIcon from "../../assets/images/infoIcon.svg";
import Backicon from "../../assets/images/mobback.svg";
import NavRight from "../../assets/images/navRight.svg";
import Closeicon from "../../assets/images/SheetClose.svg";
import TotalCard from "../../assets/images/totalCard.svg";
import { SliderComponent, Toast } from "../../components";
import axios from "../../redux/axios";
import { clearCart } from "../../redux/cart/CartAction";
import {
  comparePackagePrice,
  comparePackagePriceWithArea,
} from "../../redux/labpackage/LabPackageServices";
import "../PopularTest/ComparePrice/styles.scss";
import PKGComparisonCard from "./components/PKGComparisonCard";
import Sheet from "react-modal-sheet";
import Afribrand from "../../assets/images/afriglobal.svg";
import Clinixbrand from "../../assets/images/clinix.svg";
import Dnabrand from "../../assets/images/dna.svg";
import Docbrand from "../../assets/images/docbrand.svg";
import Echobrand from "../../assets/images/echo.svg";
import Imagebrand from "../../assets/images/imag.svg";
import Lancetbrand from "../../assets/images/lancet.svg";
import Synlabbrand from "../../assets/images/synlab.svg";
import Unionbrand from "../../assets/images/union.svg";
import ChangeLocation from "../../components/change-location/ChangeLocation";
import { clearTest } from "../../redux/auth/actions";
import { api } from "../../utils/constants";
import PartnerPop from "./components/diagnosticPartnerPop";
import SelectedPop from "./components/partnerSelectedPop";

export default function LabPackageComparePrice(_pkgDetails) {
  let history = useHistory();
  let { id } = useParams();
  let routeParams = history.location.state;
  const [comparePriceData, setComparePriceData] = useState([]);
  const [selectedPKG, setSelectedPKG] = useState([]);

  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [homeSelection, setHomeSelection] = useState([]);
  const [locationChange, setLocationChange] = useState(false);
  const [locationChangeError, setLocationChangeError] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  const [btmfilter, setbtmfilter] = useState(false);
  const [btmcart, setbtmcart] = useState(false);
  const cities = useSelector((state) => state.auth.cities);
  const partners = useSelector((state) => state.auth.partners);
  const [partnerShow, setPartnerShow] = useState(false);
  const [cpselected, setCpselected] = useState(false);
  const [brandlist, setBrandlist] = useState([]);
  const [enableHomeService, setEnableHomeService] = useState(false);
  const [update, setUpdate] = useState(false);
  const [checkoutdisplay, setCheckoutdisplay] = useState([]);
  const [totalamount, setTotalamount] = useState("");
  const [loginPop, setLoginPop] = useState(false);
  const [showAddressChangePopup, setAddressChangePopUp] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const cityState = useSelector((state) =>
    state.city !== undefined && state.city.label !== undefined ? state.city : ""
  );

  const areaState = useSelector((state) =>
    state.area !== undefined && state.area.area !== undefined
      ? state.area.area
      : ""
  );
  console.log(areaState, "areaState");
  const handleChangeAddress = () => {
    window.scroll(0, 200);
    setAddressChangePopUp(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchPackageComparePrice = async (packageId) => {
      try {
        if (packageId) {
          window.scrollTo(0, 0);
          var packageCompareData = [];

          if (cityState.value !== "" && areaState.value !== "") {
            let compareDataWithAreaResponse = await comparePackagePriceWithArea(
              packageId,
              areaState.value
            );
            packageCompareData = compareDataWithAreaResponse.data;
          } else {
            let compareDataResponse = await comparePackagePrice(packageId);
            packageCompareData.push(compareDataResponse.data);
          }
          packageCompareData = packageCompareData.map((item) => {
            return {
              ...item,
              diagnosticspartner: item.partner_name,
            };
          });
          setBrandlist({ data: packageCompareData });
          setComparePriceData(packageCompareData);
        } else {
          history.push("/popularpackages");
        }
      } catch (error) {
        if (error && error.response) {
          alert(error.response.data);
        }
      }
    };

    fetchPackageComparePrice(id);
  }, [id, cityState, areaState]);
  useEffect(() => {
    setAddressChangePopUp(true);
    checkdd();
  }, [id]);
  const checkdd = () => {
    setTimeout(() => window.scrollTo(0, 200), 1);
  };
  useEffect(() => {
    dispatch(clearCart());
    window.scrollTo(0, 0);

    const setResponsiveness = () => {
      return window.innerWidth < 600
        ? setMobileView(true)
        : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  useEffect(() => {
    if (enableHomeService === false) {
      setHomeSelection([]);
      setUpdate(!update);
    }
  }, [enableHomeService]);

  useEffect(() => {
    if (checkoutdisplay.length > 0) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [checkoutdisplay, homeSelection]);

  useEffect(() => {
    let temp = [];
    if (brandlist.data !== undefined && brandlist.data.length > 0) {
      brandlist.data.forEach((v) =>
        temp.push({
          partner_name: v.partner_name,
          package_details: [],
          homeService: [],
        })
      );
      // setCheckoutdisplay([...new Set(temp)]);
    }
  }, [brandlist]);

  const handleChangeLocation = () => {
    if (locationChange) {
      //history.push({ pathname: "/popularpackages" });
      setAddressChangePopUp(false);
      // dispatch(clearTest());
      setLocationChangeError(false);
    } else {
      setLocationChangeError(true);
    }
  };

  const userid = useSelector((state) =>
    state.auth.uuid ? state.auth.uuid : ""
  );
  const routeDatas = history.location.state;

  const handleLocationClose = () => {
    setPartnerShow(false);
    setbtmfilter(false);
  };

  const handleLocationCloseSelected = () => {
    setCpselected(false);
  };

  const handleHomeService = () => {
    setEnableHomeService(!enableHomeService);
  };

  const brandfilter = (values) => {
    handleLocationClose();

    if (values.length > 0) {
      const filterbrand = brandlist.data.filter((item) =>
        values.includes(item.partner_name)
      );
      let temp = { data: {} };
      temp.data = filterbrand;
      setBrandlist(temp);
    }
  };


  const [areaRef, setAreaRef] = useState()


  const onPackageAdd = async (healthPackage) => {
    if (areaState.value === "") {
      setAddressChangePopUp(true);
    } else {
      var _selectedPKG = _.cloneDeep(selectedPKG);
      _selectedPKG.push(healthPackage);
      setSelectedPKG(_selectedPKG);

      var newCheckoutdisplay = _.cloneDeep(checkoutdisplay);
      newCheckoutdisplay.push(healthPackage);
      setCheckoutdisplay(newCheckoutdisplay);
    }
  };

  const onPackageRemove = async (healthPackage) => {
    var _selectedPKG = _.cloneDeep(selectedPKG);
    var newCheckoutdisplay = _.cloneDeep(checkoutdisplay);
    _selectedPKG = _selectedPKG.filter(
      (item) =>
        item.package_details &&
        item.package_details.length > 0 &&
        healthPackage.package_details &&
        healthPackage.package_details.length > 0 &&
        item.package_details[0].uuid !== healthPackage.package_details[0].uuid
    );
    setSelectedPKG(_selectedPKG);
    newCheckoutdisplay = newCheckoutdisplay.filter(
      (item) =>
        item.package_details &&
        item.package_details.length > 0 &&
        healthPackage.package_details &&
        healthPackage.package_details.length > 0 &&
        item.package_details[0].uuid !== healthPackage.package_details[0].uuid
    );
    setCheckoutdisplay(newCheckoutdisplay);
  };

  const onHomeServiceAdd = (service) => {
    var newHomeSelection = _.cloneDeep(homeSelection);
    newHomeSelection.push(service);
    setHomeSelection(newHomeSelection);
  };

  const onHomeServiceRemove = (service) => {
    var newHomeSelection = _.cloneDeep(homeSelection);
    newHomeSelection.pop(service);
    setHomeSelection(newHomeSelection);
  };

  // const d = [{ id: 1 }].filter(v => !([].some(e => e.id === v.id)))
  // console.log(d);

  const addToCart = () => {
    let cartItem = {
      instructions: " ",
      reference_id: "",
      user_uuid: userid,
      amount: 0,
      type: "package",
      items: [
        {
          booking_uuid: "",
          city_uuid: "",
          doctor_uuid: "",
          e_uuid: "",
          home_service_available: "available",
          home_service_included: "no",
          home_service_uuid: "",
          isRecommendedTest: false,
          lab_partner_name: "ECHOLAB",
          name: "ABO Antibody titre",
          patient_name: [""],
          patient_uuid: "",
          type: "popular",
          user_uuid: userid,
          uuid: "LPTD-8FB31C84",
          test: "tests[i]",
        },
      ],
      deliveryAddress: [],
      package_details: "package_details",
    };

    checkoutdisplay.forEach((item) => {
      let isHomeServiceIncluded =
        homeSelection.filter(
          (home) =>
            item.homeservice &&
            item.homeservice.length > 0 &&
            home.uuid === item.homeservice[0].uuid
        ).length > 0;
      cartItem.amount = item.amount;
      if (item.tests) {
        cartItem.items = item.tests.map((test) => {
          let obj = {
            booking_uuid: "",
            city_uuid:  cityState.value ? cityState.value : "",
            doctor_uuid: "",
            e_uuid: "",
            home_service_available:
              test.homeserviceavailability === "AVAILABLE"
                ? "available"
                : "notavailable",
            home_service_included: isHomeServiceIncluded ? "yes" : "no",
            home_service_uuid: "",
            isRecommendedTest: false,
            lab_partner_name: test.diagnosticspartner,
            name: test.standardisedtestname,
            patient_name: [""],
            patient_uuid: "",
            type: "popular",
            user_uuid: userid,
            uuid: test.uuid,
            tests: test,
          };
          return obj;
        });
      }
      cartItem.package_details = item.package_details;
    });

    if (userid === "") {
      setLoginPop(true);
      setTimeout(() => {
        localStorage.clear();
        localStorage.setItem("COMPAREPRICEDATA", JSON.stringify(routeDatas));
        localStorage.setItem("cartItem", JSON.stringify(cartItem));
        history.push("/login");
      }, 2000);
    } else {
      var config = {
        method: "post",
        url: api.compareprice_post,
        headers: {
          "Content-Type": "application/json",
        },
        data: cartItem,
      };
      axios(config)
        .then(function (response) {
          if (response.data.status === "Success") {
            history.push({
              pathname: "/cart-update",
              state: { realtive: null, myself: null },
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const handlePartner = () => {
    window.scroll(0, 200);
    setPartnerShow(true);
  };

  useEffect(() => {
    let displayTotalAmount = 0;

    checkoutdisplay &&
      checkoutdisplay.map(
        (item) =>
          (displayTotalAmount =
            Number(displayTotalAmount) + Number(item.amount))
      );

    homeSelection &&
      homeSelection.forEach((item) => {
        displayTotalAmount =
          Number(displayTotalAmount) +
          Number(item.doctallsexclusivediscountedprice);
      });

    setTotalamount(displayTotalAmount);
  }, [checkoutdisplay, homeSelection]);

  const getTotalDisplayAmount = () => {
    let amount = 0;
    if (enableHomeService === false) {
      checkoutdisplay &&
        checkoutdisplay.forEach((item) => {
          amount = Number(amount) + Number(item.amount);
        });
    } else {
      checkoutdisplay &&
        checkoutdisplay.forEach((item) => {
          amount = Number(amount) + Number(item.amount);
        });
    }

    return amount.toFixed();
  };

  return (
    <>
      <Layout>
        <div className="price-compare-outer-container">
          {!mobileView ? (
            <div className="header-row-pc">
              <img
                src={Homeicon}
                alt="HomeImg"
                onClick={() => history.goBack()}
              />
              <img src={DisableRight} alt="Rightnav" />
              <div
                className="header-text"
                onClick={() => history.push("/popularpackages")}
                style={{ cursor: "pointer" }}
              >
                Diagnostic Packages
              </div>
              <img src={NavRight} alt="navRight" />
              <div className="header-text" style={{ color: "#163E8C" }}>
                Compare Package Prices
              </div>
            </div>
          ) : (
            <div className="header-back-row" onClick={() => history.goBack()}>
              <img src={Backicon} alt="Backicon" />
              <div className="back-text">Back</div>
            </div>
          )}
          <div className="heading-font">Compare and Select </div>
          <div className="note-cont-cls">
            <div className="note-outer-cont">
              <div className="inner-text">
                <span>
                  <img src={InfoIcon} alt="infoIcon" />
                </span>
                &nbsp;You can select tests from one partner to save some money
                on Home service
              </div>
            </div>
          </div>
          <div className="sample-row">
            <div className="left-content">
              {!mobileView ? (
                <div
                  className="partner-popup-open"
                  onClick={() => {
                    window.scroll(0, 200);
                    handlePartner();
                  }}
                >
                  <div className="left-conte">
                    <div className="text-cls">Showing</div>
                    <div className="count-out">
                      <span>
                        {brandlist && brandlist.data !== undefined
                          ? `${brandlist.data.length}/${partners.length}`
                          : `0/0`}
                      </span>
                    </div>
                    <div className="text-cls">Partners</div>
                  </div>

                  <img src={ArrowDown} alt="ArrowDown" />
                </div>
              ) : (
                <>
                  <div
                    className="partner-popup-open"
                    onClick={() => {
                      !mobileView
                        ? setPartnerShow(!partnerShow)
                        : setbtmfilter(!btmfilter);
                    }}
                  >
                    <div className="left-conte">
                      <div className="text-cls">Select Diagnostic Partner</div>
                    </div>

                    <img src={ArrowDown} alt="ArrowDown" />
                  </div>
                  <div className="mob-details">
                    {`Showing comparison details for ${
                      brandlist.data !== undefined && brandlist.data.length
                    } of 11 partners`}
                  </div>
                </>
              )}

              {/* <div className="home-sample-container-out">
                <div className="left-div">Home Sample Collection Include</div>
                <div className="right-div">
                  <input
                    class="tgl tgl-light"
                    id="homw-service-top"
                    type="checkbox"
                    onChange={handleHomeService}
                  />
                  <label class="tgl-btn" for="homw-service-top"></label>
                </div>
              </div> */}
            </div>
            {!mobileView && (
              <div className="right-content" onClick={handleChangeAddress}>
                <div className="text-select">Selected Location</div>
                <div className="loc-container-out">
                  <div className="left-cont">City:{cityState.label} </div>
                  <div className="right-cont-outer">
                    <div className="left-cls">Area:{areaState.label}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="card-container-outer">
            <div className="container card-cont">
              <div className="row">
                <div className="col-md-12 col-6">
              {/* Compare Price Card start */}
              {/* <div
                style={{
                  marginTop: "28px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  width: "50%",
                }}
              > */}
                {comparePriceData.length > 0 ? (
                  comparePriceData.map((pkg, index) => (
                    <div key={`${index}${pkg}`}>
                      <PKGComparisonCard
                        enableHomeService={enableHomeService}
                        key={`${index}`}
                        _package={pkg}
                        onAddToCart={onPackageAdd}
                        onRemoveFromCart={onPackageRemove}
                        onAddHomeService={onHomeServiceAdd}
                        onRemoveHomeService={onHomeServiceRemove}
                      />
                    </div>
                  ))
                ) : (
                  <div className="">
                    <div
                      className="bottom-content"
                      style={{
                        background: "#eff5ff",
                        border: "1px solid #87b4f8",
                        maxWidth: "1200px",
                        minHeight: "100px",
                        padding: "20px",
                      }}
                    >
                      “We are sorry none of our 12 lab partners are providing
                      this lab pack in your selected location”, Kindly look for
                      nearby Location, or connect us our support team will help
                      you in finding one”
                    </div>
                  </div>
                )}
              </div>
              {/* Compare Price Card End */}
              {/* <div></div> */}
              {/* </div> */}
              </div>
            </div>

            {(!mobileView && (
              <div className="right-card-outer" >
                <div className="right-card-outer-top">
                  <div className="top-content">
                    <img src={Bulb} alt="Bulb" />
                    <div className="help-font">Help Tip</div>
                  </div>
                  <div className="bottom-content">
                    {/* You can click on “edit” to edit your location and maybe get
                    better offers for the tests. */}
                    Explore all available partners: Scroll down to view the complete list of partners providing the selected tests in this location.
                  </div>
                </div>
                {show === false ? (
                  <div className="total-card-outer">
                    <div className="total-card-head-font">Total Amount</div>
                    <div className="img-cls">
                      <img src={TotalCard} alt="Totalcardimg" />
                    </div>
                    <div className="info-text">
                      You don’t have any partner or test selected yet
                    </div>
                    <div className="checkout-btn">
                      <span>Proceed to Checkout</span>
                    </div>
                  </div>
                ) : (
                  <div className="checkout-card-outer" >
                    <div className="header-font" >Cart </div>

                    {checkoutdisplay.map((valuess, ind) => {
                      var sTotal = 0;
                      sTotal = sTotal + valuess.amount;
                      return valuess.package_details &&
                        valuess.package_details.length > 0 ? (
                         
                        <>
                          <div className="checkout-price-display">
                            <div className="checkout-price-display-card-out">
                              <div className="header-content-out">
                                <div className="img-cls">
                                {console.log(valuess.partner_name,"valuess.partner_name")}
                                  {valuess.partner_name === "SYNLAB" ? (
                                    <img src={Synlabbrand} alt="Synlabbrand" />
                                  ) : valuess.partner_name === "ECHOLAB" ? (
                                    <img src={Echobrand} alt="Echobrand" />
                                  ) : valuess.partner_name ===
                                    "UNION DIAGNOSTICS" ? (
                                    <img src={Unionbrand} alt="Unionbrand" />
                                  ) : valuess.partner_name ===
                                    "IMAGE DIAGNOSTICS" ? (
                                    <img src={Imagebrand} alt="Imagebrand" />
                                  ) : valuess.partner_name === "DNA LABS" ? (
                                    <img src={Dnabrand} alt="Dnabrand" />
                                  ) : valuess.partner_name === "CLINIX" ? (
                                    <img src={Clinixbrand} alt="Clinixbrand" />
                                  ) : valuess.partner_name ===
                                    "CLINA LANCET" ? (
                                    <img src={Lancetbrand} alt="Lancetbrand" />
                                  ) : valuess.partner_name === "AFRIGLOBAL" ? (
                                    <img src={Afribrand} alt="Afribrand" />
                                  ) : valuess.partner_name === "DOCTALL" ? (
                                    <img src={Docbrand} alt="Docbrand" />
                                  ) : (
                                    <div className="heading-font-cheapest">
                                      {valuess.partner_name}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {valuess &&
                                valuess.package_details &&
                                valuess.package_details.length > 0 && (
                                  <div className="card-items-wrap">
                                    <div className="header-price-row">
                                      <div className="left-font">
                                        {valuess.package_details[0].panel_name}
                                      </div>
                                      <div className="right-font">
                                        ₦ {Number(valuess.amount).toFixed()}
                                      </div>
                                    </div>
                                    <div className="divider"></div>
                                  </div>
                                )}
                              {valuess &&
                                homeSelection &&
                                valuess.homeservice.map((data, ind) => {
                                  const isSelected = homeSelection.some(
                                    (ele) => ele.uuid === data.uuid
                                  );
                                  if (isSelected) {
                                    sTotal =
                                      Number(sTotal) +
                                      Number(
                                        data.doctallsexclusivediscountedprice
                                      );

                                    return (
                                      <div className="inner-card-out">
                                        <div className="left-font">
                                          Home Service
                                        </div>
                                        <div className="right-font">
                                          (₦
                                          {
                                            data.doctallsexclusivediscountedprice
                                          }
                                          )
                                        </div>
                                      </div>
                                    );
                                  } else {
                                    return null;
                                  }
                                })}

                              <div className="total-row-bottom">
                                <div className="left-font">Sub Total</div>
                                <div className="right-font">₦{sTotal}</div>
                              </div>
                            </div>
                          </div>
                          {ind === checkoutdisplay.length - 1 ? (
                            <div className="total-row-bottom">
                              <div className="left-font">Total Amount</div>
                              <div className="right-font">₦ {totalamount}</div>
                            </div>
                          ) : null}
                        </>
                      ) : (
                        ""
                      );
                    })}

                    <div
                      className="checkout-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => addToCart()}
                    >
                      <span>Proceed to Checkout</span>
                    </div>
                  </div>
                )}
              </div>
            )) ||
              ""}
          </div>

          {!mobileView && (
            <div className="bottom-carousel-compare-price">
              <SliderComponent />
            </div>
          )}
        </div>

        <Sheet
          isOpen={btmcart}
          snapPoints={[800, 400, 100, 0]}
          onClose={() => setbtmcart(false)}
          scroll="yes"
          style={{ overflowY: "scroll"}}
         
        >
          <Sheet.Container  >
            <Sheet.Header />
            <Sheet.Content scroll="yes"  >
              <div className="mob-right-card-outer" >
                <div className="top-font">
                  <img
                    alt="icon"
                    src={Closeicon}
                    onClick={() => setbtmcart(false)}
                  />
                  Cart
                </div>
                {show === false ? (
                  <>
                    <div className="total-card-outer">
                      <div className="img-cls">
                        <img src={TotalCard} alt="Totalcardimg" />
                      </div>
                      <div className="info-text">
                        You haven’t added any test
                        <br />
                        to cart yet
                      </div>
                    </div>
                    <div className="checkout-btn">
                      <span>Proceed to Checkout</span>
                    </div>
                  </>
                ) : (
                  <div className="checkout-card-outer">
                    <div className="header-font">Cart </div>

                    {checkoutdisplay.map((valuess, ind) => {
                      let sTotal = 0;
                      return valuess.package_details &&
                        valuess.package_details.length > 0 ? (
                        <>
                          <div className="checkout-price-display">
                            <div className="checkout-price-display-card-out">
                              <div className="header-content-out">
                                <div className="img-cls">
                                  {valuess.partner_name === "SYNLAB" ? (
                                    <img src={Synlabbrand} alt="Synlabbrand" />
                                  ) : valuess.partner_name === "ECHOLAB" ? (
                                    <img src={Echobrand} alt="Echobrand" />
                                  ) : valuess.partner_name ===
                                    "UNION DIAGNOSTICS" ? (
                                    <img src={Unionbrand} alt="Unionbrand" />
                                  ) : valuess.partner_name ===
                                    "IMAGE DIAGNOSTICS" ? (
                                    <img src={Imagebrand} alt="Imagebrand" />
                                  ) : valuess.partner_name === "DNA LABS" ? (
                                    <img src={Dnabrand} alt="Dnabrand" />
                                  ) : valuess.partner_name === "CLINIX" ? (
                                    <img src={Clinixbrand} alt="Clinixbrand" />
                                  ) : valuess.partner_name ===
                                    "CLINA LANCET" ? (
                                    <img src={Lancetbrand} alt="Lancetbrand" />
                                  ) : valuess.partner_name === "AFRIGLOBAL" ? (
                                    <img src={Afribrand} alt="Afribrand" />
                                  ) : valuess.partner_name === "DOCTALL" ? (
                                    <img src={Docbrand} alt="Docbrand" />
                                  ) : (
                                    <div className="heading-font-cheapest">
                                      {valuess.partner_name}
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="card-items-wrap">
                                <div className="header-price-row">
                                  <div className="left-font">
                                    {valuess.package_details[0].panel_name}
                                  </div>
                                  <div className="right-font">
                                    ₦ {Number(valuess.amount).toFixed()}
                                  </div>
                                </div>
                                <div className="divider"></div>
                              </div>

                              {valuess.homeService &&
                                valuess.homeService.map((data, ind) => {
                                  sTotal =
                                    Number(sTotal) +
                                    Number(
                                      data.doctallsexclusivediscountedprice
                                    );

                                  return (
                                    <div className="inner-card-out">
                                      <div className="left-font">
                                        Home Service
                                      </div>
                                      <div className="right-font">
                                        (₦
                                        {data.doctallsexclusivediscountedprice})
                                      </div>
                                    </div>
                                  );
                                })}

                              <div className="total-row-bottom">
                                <div className="left-font">Sub Total</div>
                                <div className="right-font">₦{sTotal}</div>
                              </div>
                            </div>
                          </div>
                          {ind === checkoutdisplay.length - 1 ? (
                            <div className="total-row-bottom">
                              <div className="left-font">Total Amount</div>
                              <div className="right-font">
                                ₦{getTotalDisplayAmount()}
                              </div>
                            </div>
                          ) : null}
                        </>
                      ) : (
                        ""
                      );
                    })}

                    <div
                      className="checkout-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => addToCart()}
                    >
                      <span>Proceed to Checkout</span>
                    </div>
                  </div>
                )}
              </div>
            </Sheet.Content>
          </Sheet.Container>
          <Sheet.Backdrop />
        </Sheet>

        <Modal show={partnerShow} onHide={handleLocationClose}>
          <PartnerPop
            resp={brandlist}
            brandfilter={brandfilter}
            close={() => setPartnerShow(false)}
          />
        </Modal>

        <Modal show={cpselected} onHide={handleLocationCloseSelected}>
          <SelectedPop />
        </Modal>

        <Modal
          show={showAddressChangePopup}
          onHide={() => {
            setAddressChangePopUp(false);
            setLocationChangeError(false);
          }}
          style={{ marginTop: "100px" }}
        >
          <ChangeLocation
            // city={cities}
            // handleChangeLocation={handleChangeLocation}
            ty="lab"
            city={cities}
            cityState={cityState}
            handleChangeLocation={handleChangeLocation}
            setAreaRef={()=>setAreaRef()}
            areaRef= {areaRef}
            handleLocationChange={() => setLocationChange(true)}
            setAddressChangePopUp={() => setAddressChangePopUp(false)}
            setLocationChangeError={() => setLocationChangeError(false)}
          />

          <Modal.Footer></Modal.Footer>
        </Modal>

        <Toast
          text={"Please Login to Continue"}
          type="warning"
          open={loginPop}
          setClose={() => {
            setLoginPop(false);
          }}
        />

        <Toast
          text={"Please select city and area"}
          type="warning"
          open={locationChangeError}
          setClose={() => {
            setLocationChange(false);
          }}
        />

        <Toast
          text={"Added Test is not available for saved location"}
          type="warning"
          open={errorToast}
          setClose={() => {
            setErrorToast(false);
          }}
        />
      </Layout>
    </>
  );
}
